'use strict';

var React = require('react'),
    Link = require('../atoms/Link'),
    ModalActionCreators = require('../actions/ModalActionCreators'),
    ModalTypes = require('../constants/ModalTypes'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./Footer.less');

var Footer = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  render() {
    return (
      <div className={this.getClassName()}>
        <ul className='Footer-list'>
          <li className='Footer-item'>
            <Link to='about'
                  underline='never'>
              About&nbsp;Stampsy
            </Link>
          </li>

          <li className='Footer-item'>
            <Link to='terms'
                  underline='never'>
              Terms&nbsp;of&nbsp;Service
            </Link>
          </li>

          <li className='Footer-item'>
            <Link to='privacy'
                  underline='never'>
              Privacy&nbsp;Policy
            </Link>
          </li>

          <li className='Footer-item'>
            <Link onClick={this.handleContactClick}
                  underline='never'>
              Contact&nbsp;Us
            </Link>
          </li>

          <li className='Footer-item'>
            <Link href='https://www.facebook.com/HelloStampsy'
                  target='_blank'
                  underline='never'>
              Facebook
            </Link>
          </li>

          <li className='Footer-item'>
            <Link href='https://twitter.com/HelloStampsy'
                  target='_blank'
                  underline='never'>
              Twitter
            </Link>
          </li>

          <li className='Footer-item'>
            <Link href='https://www.pinterest.com/HelloStampsy/'
                  target='_blank'
                  underline='never'>
              Pinterest
            </Link>
          </li>
        </ul>
      </div>
    );
  },

  handleContactClick() {
    ModalActionCreators.showModal(ModalTypes.CONTACT_US);
  }
});

module.exports = Footer;



/** WEBPACK FOOTER **
 ** ./organisms/Footer.jsx
 **/